import React, { Component } from "react";
import { Log } from "@learningblocks/shared-components";
import { LogEvent } from "@learningblocks/shared-components/lib/EventLogger";
import { v4 as uuidv4 } from "uuid";
import {
  UsersnapProvider,
  loadUsersnapScrollable,
} from "@labxchange/util-usersnap";
import "./index.css";
import background from "../images/background.svg";
import oldBackground from "../images/old-background.svg";

import i18next from "i18next";

import AnimationContainer from "../Animation-Container";
import CompressedAnimationContainer from "../Compressed-Animation-Container";
import DescriptionContainer from "../Description-Container";
import NavigationMain from "../Navigation-Main";
import DescriptionNavigation from "../Description-Navigation";
import {
  HighlightProvider,
  calculateTooltipPosition,
} from "@learningblocks/shared-components";

import StartScreen from "../Splash-Screens/Start-Screen";
import EndScreen from "../Splash-Screens/End-Screen";

// Import suppoted languages (Add to confitional use statement)
import UI_ar from "../../locales/ar/translation.json";
import UI_de from "../../locales/de/translation.json";
import UI_en from "../../locales/en/translation.json";
import UI_es from "../../locales/es/translation.json";
import UI_fr from "../../locales/fr/translation.json";
import UI_it from "../../locales/it/translation.json";
import UI_ja from "../../locales/ja/translation.json";
import UI_ko from "../../locales/ko/translation.json";
import UI_nl from "../../locales/nl/translation.json";
import UI_pt from "../../locales/pt/translation.json";
import UI_tr from "../../locales/tr/translation.json";
import UI_zh from "../../locales/zh/translation.json";
import UI_zu from "../../locales/zu/translation.json";
import UI_vi from "../../locales/vi/translation.json";
import UI_uk from "../../locales/uk/translation.json";
import UI_az from "../../locales/az/translation.json";

const SESSION_ID = uuidv4();
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

class ScrollyContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      percentage: 0,
      currentDescriptionID: null, // Updated by description content element and passed to animation for alt text element
      forcedProgress: null, // Determined in navigation elements to force or prevent a change to the animation progress
      forceScrollUpdate: false, // When made true by description nav, a function in animation element will adjust scroll position and set back to false tom complete update
      adjustFrame: 0, // A value set to forward the animation by 1 fame in order to account for matching end/start times during navigation
      totalTime: null, // total time in seconds, set by animation when loaded
      totalFrames: null, // Used to set height of animation-scroll element
      animationReady: false,
      sceneData: this.props.sceneData,
      scrollActive: true, // toggle scrolling updates (widget lock)
      preview: this.props.animationLink ? true : false,
      previewAnimation: {},
      previewAnimationReady: false,
      lang: "en",
      ariaHideSplashScreens: false,
    };
  }

  componentDidMount() {
    if (
      Object.prototype.hasOwnProperty.call(
        this.state.sceneData.Scrolly,
        "background"
      )
    ) {
      // Apply latest styles based on Airtable configuration (preview or not)
      if (this.state.sceneData.Scrolly.background) {
        document.body.style.backgroundColor = "rgb(16,46,77)";
      }
    }

    let currentLang = urlParams.get("lng");
    if (currentLang === null) {
      currentLang = "en";
    }
    this.setState({
      lang: currentLang,
    });

    i18next.addResourceBundle(
      "en",
      "translation", // Supported languages used
      currentLang == "ar"
        ? UI_ar
        : currentLang == "de"
          ? UI_de
          : currentLang == "en"
            ? UI_en
            : currentLang == "es"
              ? UI_es
              : currentLang == "fr"
                ? UI_fr
                : currentLang == "it"
                  ? UI_it
                  : currentLang == "ja"
                    ? UI_ja
                    : currentLang == "ko"
                      ? UI_ko
                      : currentLang == "nl"
                        ? UI_nl
                        : currentLang == "pt"
                          ? UI_pt
                          : currentLang == "tr"
                            ? UI_tr
                            : currentLang == "zh"
                              ? UI_zh
                              : currentLang == "uk"
                                ? UI_uk
                                : currentLang == "az"
                                  ? UI_az
                                  : currentLang == "vi"
                                    ? UI_vi
                                    : currentLang == "zu"
                                      ? UI_zu // Add language support by importing the file above and adding a new line here: ": currentlang == lang ? UI_lang"
                                      : UI_en,
      true,
      true
    );

    if (this.props.stringData) {
      i18next.addResourceBundle(
        "en",
        "translation",
        this.props.stringData,
        true,
        true
      );
    }

    this.setBreakpoint(); // Set up screen-size styling parameters on load

    window.addEventListener(
      // Adjust breakpoints when window is resized
      "resize",
      () => {
        this.setBreakpoint();
      }
    );

    if (this.props.animationLink) {
      this.fetchAnim(this.props.animationLink).then((data) => {
        if (this.props.AnimationImages) {
          this.props.AnimationImages.map((image) => {
            const filename = image.filename.substring(
              0,
              image.filename.length - 4
            );
            data.assets.map((asset) => {
              const name = asset.id.replace("image_", "img_");
              if (filename === name) {
                asset.u = "";
                asset.p = image.url;
              }
            });
          });
        }
        this.setState({
          previewAnimation: data,
          previewAnimationReady: true,
        });
      });
    }
  }

  fetchAnim = async (url = "") => {
    const response = await fetch(url);
    const anim = await response.json();
    return anim;
  };

  setBreakpoint = () => {
    // Breakpoint thresholds and assignments
    const width = window.innerWidth;
    if (width > 1500) {
      this.setState({ breakpoint: "xl" });
    }
    if (width <= 1500) {
      this.setState({ breakpoint: "lg" });
    }
    if (width <= 1024) {
      this.setState({ breakpoint: "md" });
    }
    if (width <= 720) {
      this.setState({ breakpoint: "sm" });
    }
    if (width <= 320) {
      this.setState({ breakpoint: "xs" });
    }
  };

  updatePercentage = (percentage) => {
    // Update percentage from frame changes to set run limit (animation element)
    this.setState({
      percentage: percentage,
      adjustFrame: 0, // reset after navigation
    });
  };

  forceAnimationTo = (percentage, adjustFrame) => {
    if (percentage > 100) {
      percentage = 100;
    }
    if (adjustFrame !== undefined) {
      this.setState({
        adjustFrame: adjustFrame,
        forcedProgress: percentage,
      });
    } else {
      this.setState({ forcedProgress: percentage });
    }
  };

  forceScroll = (action) => {
    // Toggle scroll update to only update scroll position when needed
    if (action === "nav") {
      this.setState({ forceScrollUpdate: true });
    } else {
      this.setState({ forceScrollUpdate: false });
    }
  };

  updateCurrentDescription = (id) => {
    this.setState({ currentDescriptionID: id });
  };

  setTotalTime = (seconds) => {
    this.setState({ totalTime: seconds });
  };

  setScrollActive = (bool) => {
    this.setState({ scrollActive: bool });
  };

  setAnimationReady = () => {
    this.setState({ animationReady: true });
  };

  setAriaHideSplashScreens = (val) => {
    this.setState({
      ariaHideSplashScreens:
        val === "start" || val === "end" ? val : "animation",
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  logStart = () => {}; // required for start event logging trigger

  render() {
    return (
      <Log
        scr_name={this.state.sceneData.Scrolly.title_en}
        scr_session_id={SESSION_ID}
      >
        <HighlightProvider.Component
          calculateTooltipPosition={calculateTooltipPosition}
        >
          <div
            id="app-container"
            className="app-container"
            style={{
              backgroundImage: this.state.sceneData.Scrolly.background
                ? `url(${background})`
                : `url(${oldBackground})`,
            }}
          >
            <StartScreen
              bp={this.state.breakpoint}
              sceneData={this.state.sceneData}
              animationReady={this.state.animationReady}
              ariaHideSplashScreens={this.state.ariaHideSplashScreens}
            />
            <div
              role="main"
              className={`mainContainer ${this.state.breakpoint === "lg" || this.state.breakpoint === "xl" ? "mainContainer_desktop" : ""}`}
            >
              <div
                className={`mainContentContainer ${this.state.breakpoint === "lg" || this.state.breakpoint === "xl" ? "mainContentContainer_desktop" : ""} ${this.state.breakpoint === "xl" ? "mainContentContainer_xl" : ""}`}
              >
                <DescriptionContainer
                  // Container for content (widgets/descriptions)
                  sceneData={this.state.sceneData}
                  percentage={this.state.percentage}
                  forceAnimationTo={this.forceAnimationTo}
                  forceScroll={this.forceScroll}
                  currentDescriptionID={this.state.currentDescriptionID}
                  updateCurrentDescription={this.updateCurrentDescription}
                  totalTime={this.state.totalTime}
                  totalFrames={this.state.totalFrames}
                  bp={this.state.breakpoint}
                  scrollActive={this.state.scrollActive}
                  setScrollActive={this.setScrollActive}
                  plotFunctions={this.props.plotFunctions}
                  debug={
                    this.state.sceneData.Scrolly.debug === "" ? false : true
                  }
                  preview={this.state.preview}
                  setAriaHideSplashScreens={this.setAriaHideSplashScreens}
                />
                {this.state.preview && this.state.previewAnimationReady ? (
                  <AnimationContainer
                    animationLink={this.props.animationLink}
                    previewAnimation={this.state.previewAnimation}
                    percentage={this.state.percentage}
                    currentDescriptionID={this.state.currentDescriptionID}
                    updatePercentage={this.updatePercentage}
                    forceAnimationTo={this.forceAnimationTo}
                    forcedProgress={this.state.forcedProgress}
                    adjustFrame={this.state.adjustFrame}
                    forceScrollUpdate={this.state.forceScrollUpdate}
                    forceScroll={this.forceScroll}
                    setTotalTime={this.setTotalTime}
                    animationReady={this.state.animationReady}
                    setAnimationReady={this.setAnimationReady}
                    bp={this.state.breakpoint}
                    scrollActive={this.state.scrollActive}
                    sceneData={this.state.sceneData}
                    debug={
                      this.state.sceneData.Scrolly.debug === "" ? false : true
                    }
                    ariaHideSplashScreens={this.state.ariaHideSplashScreens}
                  />
                ) : null}
                {!this.state.preview ? (
                  <CompressedAnimationContainer
                    animationData={this.props.animationData}
                    percentage={this.state.percentage}
                    currentDescriptionID={this.state.currentDescriptionID}
                    updatePercentage={this.updatePercentage}
                    forceAnimationTo={this.forceAnimationTo}
                    forcedProgress={this.state.forcedProgress}
                    adjustFrame={this.state.adjustFrame}
                    forceScrollUpdate={this.state.forceScrollUpdate}
                    forceScroll={this.forceScroll}
                    setTotalTime={this.setTotalTime}
                    animationReady={this.state.animationReady}
                    setAnimationReady={this.setAnimationReady}
                    bp={this.state.breakpoint}
                    scrollActive={this.state.scrollActive}
                    sceneData={this.state.sceneData}
                    debug={
                      this.state.sceneData.Scrolly.debug === "" ? false : true
                    }
                    animLng={this.props.animLng}
                    ariaHideSplashScreens={this.state.ariaHideSplashScreens}
                  />
                ) : null}
              </div>
            </div>
            <DescriptionNavigation
              // Description nav buttons (& percentage)
              sceneData={this.state.sceneData}
              percentage={this.state.percentage}
              forceAnimationTo={this.forceAnimationTo}
              forceScroll={this.forceScroll}
              descriptionID={this.state.currentDescriptionID}
              totalTime={this.state.totalTime}
              bp={this.state.breakpoint}
            />
            <LogEvent
              logEventProps={
                // Handles scrollable start / loaded
                this.state.animationReady
                  ? {
                      event_type: "scr_start",
                      event_schema: "scrollableStart",
                    }
                  : null
              }
              actionProps={{ logStart: { action: "viewed" } }}
              elementType="div"
            >
              <NavigationMain
                // Custom main/timeline/contents navigation
                loaded={this.state.animationReady}
                sceneData={this.state.sceneData}
                percentage={this.state.percentage}
                forceAnimationTo={this.forceAnimationTo}
                forceScroll={this.forceScroll}
                currentDescriptionID={this.state.currentDescriptionID}
                totalTime={this.state.totalTime}
                bp={this.state.breakpoint}
                logStart={this.logStart}
              />
            </LogEvent>
            <EndScreen
              bp={this.state.breakpoint}
              sceneData={this.state.sceneData}
              ariaHideSplashScreens={this.state.ariaHideSplashScreens}
              lang={urlParams.get("lng")}
            />
          </div>
        </HighlightProvider.Component>
      </Log>
    );
  }
}

//loading the usernsap widget on the same level as the scrollable refreshes the request when the scrollable component updates.
//This wrapper prevents the usersnap provider from constantly relaoding the widget.
export default class Scrolly extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <UsersnapProvider
        onLoadCallback={(event, api) =>
          loadUsersnapScrollable(event, api, urlParams.get("lng"))
        }
      >
        <ScrollyContent {...this.props} />
      </UsersnapProvider>
    );
  }
}
